import React from "react";
import { Link } from "react-router-dom";
import "./HeroSlider.css";

const Hero = () => {
  return (
    <section id="home" className="hero-section">
      {/* Dark overlay for better text readability */}
      <div className="hero-overlay"></div>

      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">Building a Stronger Welfare Family</h1>
          <p className="hero-description">
            The ACESWA portal allows members to join, contribute, and grow
            together in transparency. Designed to simplify your welfare journey
            — so every contribution counts and every member stays informed.
          </p>

          <div className="hero-buttons">
            <Link to="" className="btn-primary">
              Join us Today
            </Link>
          </div>
        </div>
      </div>

      {/* === Top Background SVG === */}
      <div className="hero-bg-top">
        <svg
          width="450"
          height="556"
          viewBox="0 0 450 556"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="277" cy="63" r="225" fill="url(#blue_grad_0)" />
          <circle cx="18" cy="182" r="18" fill="url(#blue_grad_1)" />
          <circle cx="77" cy="288" r="34" fill="url(#blue_grad_2)" />
          <circle
            cx="325.486"
            cy="302.87"
            r="180"
            transform="rotate(-37.6852 325.486 302.87)"
            fill="url(#blue_grad_3)"
          />
          <circle
            opacity="0.9"
            cx="184.521"
            cy="315.521"
            r="132.862"
            transform="rotate(114.874 184.521 315.521)"
            stroke="url(#blue_grad_4)"
          />
          <circle
            opacity="0.9"
            cx="356"
            cy="290"
            r="179.5"
            transform="rotate(-30 356 290)"
            stroke="url(#blue_grad_5)"
          />
          <circle
            opacity="0.9"
            cx="191.659"
            cy="302.659"
            r="133.362"
            transform="rotate(133.319 191.659 302.659)"
            fill="url(#blue_grad_6)"
          />
          <defs>
            <linearGradient
              id="blue_grad_0"
              x1="-54.5"
              y1="-178"
              x2="222"
              y2="288"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2563eb" />
              <stop offset="1" stopColor="#2563eb" stopOpacity="0.8" />
            </linearGradient>
            <radialGradient
              id="blue_grad_1"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(18 182) rotate(90) scale(18)"
            >
              <stop stopColor="#2563eb" />
              <stop offset="1" stopColor="#2563eb" stopOpacity="0.7" />
            </radialGradient>
            <radialGradient
              id="blue_grad_2"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(77 288) rotate(90) scale(34)"
            >
              <stop stopColor="#2563eb" />
              <stop offset="1" stopColor="#2563eb" stopOpacity="0.7" />
            </radialGradient>
            <linearGradient
              id="blue_grad_3"
              x1="226.775"
              y1="-66.1548"
              x2="292.157"
              y2="351.421"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2563eb" />
              <stop offset="1" stopColor="#2563eb" stopOpacity="0.8" />
            </linearGradient>
            <linearGradient
              id="blue_grad_4"
              x1="184.521"
              y1="182.159"
              x2="184.521"
              y2="448.882"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2563eb" />
              <stop offset="1" stopColor="#2563eb" stopOpacity="0.8" />
            </linearGradient>
            <linearGradient
              id="blue_grad_5"
              x1="356"
              y1="110"
              x2="356"
              y2="470"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2563eb" />
              <stop offset="1" stopColor="#2563eb" stopOpacity="0.8" />
            </linearGradient>
            <linearGradient
              id="blue_grad_6"
              x1="118.524"
              y1="29.2497"
              x2="166.965"
              y2="338.63"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2563eb" />
              <stop offset="1" stopColor="#2563eb" stopOpacity="0.8" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      {/* === Bottom Background SVG === */}
      <div className="hero-bg-bottom">
        <svg
          width="364"
          height="201"
          viewBox="0 0 364 201"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.88928 72.3303C33.6599 66.4798 101.397 64.9086 150.178 105.427C211.155 156.076 229.59 162.093 264.333 166.607C299.076 171.12 337.718 183.657 362.889 212.24"
            stroke="url(#blue_line_0)"
          />
          <path
            d="M-22.1107 72.3303C5.65989 66.4798 73.3965 64.9086 122.178 105.427C183.155 156.076 201.59 162.093 236.333 166.607C271.076 171.12 309.718 183.657 334.889 212.24"
            stroke="url(#blue_line_1)"
          />
          <path
            d="M-53.1107 72.3303C-25.3401 66.4798 42.3965 64.9086 91.1783 105.427C152.155 156.076 170.59 162.093 205.333 166.607C240.076 171.12 278.718 183.657 303.889 212.24"
            stroke="url(#blue_line_2)"
          />
          <circle
            opacity="0.9"
            cx="214.505"
            cy="60.5054"
            r="49.7205"
            stroke="url(#blue_line_4)"
          />
          <circle cx="220" cy="63" r="43" fill="url(#blue_line_5)" />
          <defs>
            <linearGradient
              id="blue_line_0"
              x1="184.389"
              y1="69.2405"
              x2="184.389"
              y2="212.24"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2563eb" />
              <stop offset="1" stopColor="#2563eb" />
            </linearGradient>
            <linearGradient
              id="blue_line_1"
              x1="156.389"
              y1="69.2405"
              x2="156.389"
              y2="212.24"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2563eb" />
              <stop offset="1" stopColor="#2563eb" />
            </linearGradient>
            <linearGradient
              id="blue_line_2"
              x1="125.389"
              y1="69.2405"
              x2="125.389"
              y2="212.24"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2563eb" />
              <stop offset="1" stopColor="#2563eb" />
            </linearGradient>
            <linearGradient
              id="blue_line_4"
              x1="214.505"
              y1="10.2849"
              x2="212.684"
              y2="99.5816"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2563eb" />
              <stop offset="1" stopColor="#2563eb" />
            </linearGradient>
            <radialGradient
              id="blue_line_5"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(220 63) rotate(90) scale(43)"
            >
              <stop stopColor="#2563eb" />
              <stop offset="1" stopColor="#2563eb" />
            </radialGradient>
          </defs>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
